<template>
    <div class="create-university">
        <v-dialog v-model="dialog" max-width="600px">
            <v-card>
                <v-form @submit.prevent="createData" ref="form">
                    <v-card-title>
                    <span class="headline">Tạo trường</span>
                    </v-card-title>
                    <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <v-text-field v-model="form.Code" label="Mã" :rules="rules.nameRules"></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field v-model="form.Name" label="Tên" :rules="rules.codeRules"></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field v-model="form.Level" label="Cấp" ></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field v-model="form.Priority" label="Độ ưu tiên" ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                    </v-card-text>
                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="blue darken-1"
                        text
                        @click="dialog = false"
                    >
                        Thoát
                    </v-btn>
                    <v-btn
                        color="blue darken-1"
                        text
                        type="submit"
                    >
                        Lưu
                    </v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import http from '@/components/services/http-common';
import EventBus  from "@/components/services/EventBus";
export default {
    name: "UniversityCreateDialog",
    components:{

    },
    data() {
        return {
            //*************** Validate **************
            rules: {
                nameRules:[ 
                    v => !!v || 'Tên trường bắt buộc nhập',
                    v => v.length > 3 || 'Phải nhiều hơn 5 kí tự',
                ],
                codeRules:[ 
                    v => !!v || 'Mã trường bắt buộc nhập',
                    v => v.length > 3 || 'Phải nhiều hơn 5 kí tự',
                ],
                levelRule:[ 
                    v => !!v || 'Cấp bắt buộc nhập',
                ],
                priorityRule:[ 
                    v => !!v || 'Độ ưu tiên buộc nhập',
                ],
            },
            
            //************* Form config */
            message: "",
            activetab: 0,
            valid: false,
            item: undefined,
            isUpdate: false,
            dialog: false,
            IDdateMenu: false,
            HireMenu: false,
            formData: {
                departmentTypes: []
            },
            form: {
                Code: "",
                Name:"",
                Level: "1",
                Priority: "1",
            },
            defaultForm: {
                Code: "",
                Name:"",
                Level: "1",
                Priority: "1",
            },
        };
    },
    computed: {
        formTitle(){
            return this.isUpdate ? "Cập nhật phòng" : "Tạo mới phòng";
        }
    },
    watch: {
        dialog (val) {
            val || this.close();
        },
    },
    methods: {
        fetchUpdate (code){
            http.get("universities/"+code).then(res => {
                let data = res.data;
                this.form.Code = data.code;
                this.form.Name = data.name;
                this.form.Level = data.level;
                this.form.Priority = data.priority;
                console.log(data)
            }).catch(err => {
                console.log(err);
            });
        },
        close () {
            this.dialog = false;
            this.isUpdate = false;
            this.$refs.form.resetValidation();
            this.form = Object.assign({}, this.defaultForm);
        },
        fetchDepartmentType() {
            http.get("departmenttypes?dropDown=1").then(res => {
                this.formData.departmentTypes = res.data.map(function(obj) {
                return {
                    text: obj.name,
                    value: obj.code,
                    }
                });
                console.log(res.data)
                
            }).catch(err =>{
                console.log("error connection");
            });
        },
        createData () {
            this.$refs.form.validate()
            if(!this.isUpdate)
                http.post('universities', this.form).then(res => {
                    this.dialog = false;
                    this.$parent.fetchData();
                }).catch( (err) => {
                    if(err.response.status){
                        let eventObj = {
                            color: "error",
                            messages: "Đã có lỗi xảy ra, vui lòng kiểm tra lại dữ liệu !!!"
                        }
                        EventBus.$emit('hasMessage', eventObj);
                    }
                })
            else{
                http.put('universities/' + this.item.code, this.form).then((res) => {
                    this.dialog = false;
                    this.$parent.fetchData();
                }).catch( (err) => {
                    console.log("error")
                })
            }
        }
    },
    mounted() {
        // this.fetchDepartmentType();
    }
}
</script>
